import Hero from "../components/Hero";
import LineUp from "../components/LineUp";

function Home() {
  return (
    <div>
      <Hero />
      <LineUp />
    </div>
  );
}

export default Home;